import React, { useState } from "react";
import CustomerHeader from "../components/CustomerHeader";
import CustomerFooter from "../components/CustomerFooter";

function Careers() {
  const [isMobile] = useState(window.innerWidth <= 768);

  return (
    <>
      <CustomerHeader />
      <div
        style={{
          padding: isMobile ? "86px 16px 30px" : "106px 32px 42px",
          background: "#f9fafb",
        }}
      >
        <div
          style={{
            maxWidth: "900px",
            margin: "0 auto",
            background: "white",
            borderRadius: "16px",
            padding: isMobile ? "24px" : "40px",
            border: "1px solid #e5e7eb",
          }}
        >
          <h1 style={{ marginTop: 0, color: "#111827" }}>Careers at OGESTYLE</h1>
          <p style={{ color: "#4b5563", lineHeight: "1.7" }}>
            We are building tools for beauty and wellness businesses and independent
            professionals. We are not hiring right now, but new openings will be posted
            here as we scale.
          </p>

          <div
            style={{
              marginTop: "24px",
              padding: "20px",
              background: "#f3f4f6",
              borderRadius: "12px",
              color: "#374151",
            }}
          >
            No open roles at the moment.
          </div>

          <p style={{ marginTop: "20px", color: "#6b7280" }}>
            For future opportunities, send your profile to careers@ogestyle.com.
          </p>
        </div>
      </div>
      <CustomerFooter />
    </>
  );
}

export default Careers;
